import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Exclamation: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px] stroke-[2px] text-white fill-[#FFD324]', className)}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99996 2.29199C5.74276 2.29199 2.29163 5.74313 2.29163 10.0003C2.29163 14.2575 5.74276 17.7087 9.99996 17.7087C14.2572 17.7087 17.7083 14.2575 17.7083 10.0003C17.7083 5.74313 14.2572 2.29199 9.99996 2.29199ZM1.04163 10.0003C1.04163 5.05277 5.05241 1.04199 9.99996 1.04199C14.9475 1.04199 18.9583 5.05277 18.9583 10.0003C18.9583 14.9479 14.9475 18.9587 9.99996 18.9587C5.05241 18.9587 1.04163 14.9479 1.04163 10.0003ZM9.99996 6.08847C10.3451 6.08847 10.625 6.36829 10.625 6.71347V10.4172C10.625 10.7624 10.3451 11.0422 9.99996 11.0422C9.65478 11.0422 9.37496 10.7624 9.37496 10.4172V6.71347C9.37496 6.36829 9.65478 6.08847 9.99996 6.08847ZM9.32885 13.195C9.32885 12.8498 9.60867 12.57 9.95385 12.57H10.0461C10.3913 12.57 10.6711 12.8498 10.6711 13.195V13.2875C10.6711 13.4537 10.6049 13.6131 10.4871 13.7304C10.3694 13.8476 10.2098 13.9132 10.0436 13.9125L9.95139 13.9122C9.60717 13.9108 9.32885 13.6314 9.32885 13.2872V13.195Z"
      fill="#FF4035"
    />
  </svg>
);

export default Exclamation;
